import modules from './modules/module.routes.js';
export default {
    /**
     * This is app1 layout
     * Here we have some default global css imported from boostrap.
     * Children routes are fetched from `module` directory which contain some
     * business logics, and used via iframe in legacy application
     * Children routes for this app layout generated by running `npm run layout1-routes` npm command
     */
    path: '/app1',
    component: () => import(/* webpackChunkName: "app-components" */ '@/Layouts/app-component/layout.vue'),
    children: [
        {
            path: "/",
            name: "app1",
            redirect: {
                name: modules[0].name
            },
            component: () => import(/* webpackChunkName: "app-components-entry" */ './App.vue'),
            children: modules
        }
    ]
}